module.exports = __webpack_public_path__ + "img/图片24.4e391f3d.png";